export default __webpack_public_path__ + "static/media/val_conv_1.1b54ab10.png";